import { ref, defineComponent, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { appPort, appFullScreen } from '@/widget/index';
import CourseAlbume from './components/album.vue';
import CourseMeeting from './components/meeting.vue';
export default defineComponent({
    name: 'courseGuide',
    setup() {
        const isApp = appPort();
        const route = useRoute();
        let isLiveOpen = false;
        if (String(route.query.is_live_open) === '1') {
            isLiveOpen = true;
        }
        // meeting: 班期课， album： 视频 train ： omo 和 共学营
        const courseType = ref(String(route.params.type));
        let type = 'album';
        if (courseType.value == 'train') {
            type = 'meeting';
        }
        if (isApp && !isLiveOpen) {
            appFullScreen();
        }
        const updatePage = ref(false);
        const change = () => {
            if (document.visibilityState == 'visible') {
                updatePage.value = true;
            }
            else {
                updatePage.value = false;
            }
        };
        onMounted(() => {
            document.addEventListener('visibilitychange', change, false);
        });
        onUnmounted(() => {
            document.removeEventListener('visibilitychange', change, false);
        });
        return {
            courseType,
            updatePage
        };
    },
    components: {
        CourseAlbume,
        CourseMeeting
    }
});
